require 'angular'

app = angular.module('workflow.app')

# ad hoc templates that need caching
app.run ($templateCache) ->
  $templateCache.put('directives/pagination/dirPagination.tpl.html', require('../lib/dirPagination.tpl.html'))
  $templateCache.put('directives/pagination/dirPaginationResults.tpl.html', require('../lib/dirPaginationResults.tpl.html'))
  $templateCache.put('directives/pagination/dirSimplePagination.tpl.html', require('../lib/dirSimplePagination.tpl.html'))
  $templateCache.put('preferences-menu-include.html', require('../templates/preferences-menu-include.html'))

app.run ($rootScope, $interpolate) ->
  # Set the title based on the state title interpolated with the scope

  baseTitle = 'Arachnys'
  titleFn = null

  $rootScope.$on '$viewContentLoading', (event, viewConfig) ->
    if viewConfig.view.self && viewConfig.view.self.title?
      titleFn = $interpolate(viewConfig.view.self.title, false, null, true)
    else
      titleFn = null

  $rootScope.$on '$viewContentLoaded', (event) ->
    event.targetScope.$watch () ->
      if angular.isFunction(titleFn)
        title = titleFn(event.targetScope)
        $rootScope.title = if title then "#{title} - #{baseTitle}" else baseTitle
      else
        $rootScope.title = baseTitle

  errorStatusesToIgnore = [403, 404]
  $rootScope.$on '$stateChangeError', ( event, toState, toParams, fromState, fromParams, error ) ->
    return if error.status? and errorStatusesToIgnore.indexOf(error.status) isnt -1
    throw new Error( 'ui-router failed to change state. ' + error.stack )

do () ->
  # Track location history for debugging using a simple FIFO queue
  locationHistory = []
  recordLocation = (location) ->
    return if locationHistory[locationHistory.length - 1] is location
    locationHistory.push location
    locationHistory.shift() if locationHistory.length > 20

  app.run ($rootScope, $location) ->
    $rootScope.$on '$stateChangeSuccess', () ->
      if $location.path()?
        recordLocation($location.path())

app.run ($rootScope, cfpLoadingBar) ->
  # Loading bar
  $rootScope.$on '$stateChangeStart', () ->
    cfpLoadingBar.start()
  $rootScope.$on '$stateChangeSuccess', () ->
    cfpLoadingBar.complete()
  $rootScope.$on '$stateChangeError', () ->
    cfpLoadingBar.complete()

app.run ($rootScope) ->
  $rootScope.isClipboardSupported = document.queryCommandSupported? and document.queryCommandSupported('copy')
